import * as React from 'react';
import { colors } from '../../../index';

const IconCheckmark = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 8 6.5",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.345 4.807L.832 3.294 0 4.126l1.997 1.997.002-.003.364.365L8 .848 7.152 0z"
  }));
};

export default IconCheckmark;